<template>
    <div>
        <section class="m-maptop">
            <a :href="listViewUrl + '?' + filterQuerystring" class="e-back" v-if="listViewUrl">Exit Map</a>

            <div class="e-actions">
                <search-filters :show-results-count="false"></search-filters>

                <!--<a href="#" class="btn btn-green property-alerts" v-if="isLoggedIn">Property alerts</a>-->
            </div>
        </section>
        <section class="m-mapview">
            <div class="e-iteminfo" :data-status="itemInfoStatus">
                <div class="close" v-on:click="toggleItemInfoStatus()">
                    <span>&times;</span>
                    Close
                </div>
                <template v-if="propertySummary">
                    <div class="e-iteminfo__panel">
                        <div class="flow">
                            <h3>
                                <a :href="propertySummary.Url">{{propertySummary.PropertyTitle}}</a>
                            </h3>
                            <div class="image">
                                <ul class="e-data">
                                    <li v-if="propertyPhotoCount">{{propertyPhotoCount}}</li>
                                    <li v-if="propertySummary.PropertyHasDocuments">
                                        <svg aria-hidden="true" class="icon">
                                            <use xlink:href="/icons/sprite.svg#chevron-down"></use>
                                        </svg>
                                    </li>
                                    <li v-if="propertySummary.PropertyHasVideo">
                                        <svg aria-hidden="true" class="icon icon--s">
                                            <use xlink:href="/icons/sprite.svg#play"></use>
                                        </svg>
                                    </li>
                                </ul>
                                <a :href="propertySummary.Url">
                                    <thumbnail-image :photo-id="propertyPhotoId" v-if="propertyPhotoId"></thumbnail-image>
                                </a>
                            </div>
                            <div class="rich-content flow">
                                <p>
                                    {{truncate(propertySummary.PropertyDescription, 150)}}
                                </p>
                                <a :href="propertySummary.Url" class="btn">Find out more</a>
                                <profile-actions :page-id="propertySummary.Id.toString()"></profile-actions>
                            </div>
                            <div class="amount" v-if="propertySummary.PropertySaleTypeString != null">
                                {{formatAskingPrice(propertySummary)}}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div id="mapContainer">
                <GMapMap ref="gmap"
                          class="property-search-map__map"
                          :center="center"
                          :options="mapOptions"
                          style="width:100%;  height: 100%;"
                          :zoom="8">
                </GMapMap>
            </div>
        </section>
    </div>
</template>

<script>
    import Axios from 'axios'
    import ProfileActions from '@/components/Utils/profile-actions'
    import SearchFilters from '@/components/SiteSearch/search-filters'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { propertyMixin } from '@/mixins/propertyMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'
    import { createMarkerClusterer } from '@/utils/mapClusterer.js'
    import { addMapMarkerClickListener, createMapIconMarker, getAdvancedMarkerMapOptions, loadAdvancedMarkerLibraryForMap, removeMarker } from '@/utils/mapMarkers.js'
    import { truncate } from '@/utils/strings.js'

    function getPropertyLocation(content) {
        if (!content) {
            return null
        }

        const location = content.PropertyLocation || content.PropertyImportLocation

        if (!location) {
            return null
        }

        const latitude = location.latitude || location.lat || location.Latitude
        const longitude = location.longitude || location.lng || location.Longitude

        if (latitude === null || latitude === undefined || longitude === null || longitude === undefined) {
            return null
        }

        return {
            latitude: parseFloat(latitude),
            longitude: parseFloat(longitude)
        }
    }

    export default {
        components: {
            ProfileActions,
            SearchFilters,
            ThumbnailImage
        },

        computed: {
            isLoggedIn: function () {
                return isLoggedIn
            },

            filterQuerystring: {
                get() {
                    return this.$store.getters.searchFiltersQuerystring(null, null, false)
                },
                set() {
                }
            },

            mapOptions: function () {
                return getAdvancedMarkerMapOptions(this.$store.state.mapOptions)
            },

            markerIcon: function () {
                return this.$store.state.mapOptions.markerIcon
            },

            markers: function () {
                var vm = this

                return vm.$store.state.search.results && vm.$store.state.search.results.map(x => {
                    const location = getPropertyLocation(x.Content)

                    if (!location || !Number.isFinite(location.latitude) || !Number.isFinite(location.longitude)) {
                        return null
                    }

                    return {
                        position: {
                            lat: location.latitude,
                            lng: location.longitude
                        },
                        propertyId: x.Id
                    }
                }).filter(Boolean)
            },

            propertyPhotoCount: function () {
                if (!this.propertySummary || !Array.isArray(this.propertySummary.PropertyPhotos)) {
                    return 0
                }

                return this.propertySummary.PropertyPhotos.length
            },

            propertyPhotoId: function () {
                if (!this.propertySummary || !Array.isArray(this.propertySummary.PropertyPhotos)) {
                    return null
                }

                const firstPhoto = this.propertySummary.PropertyPhotos[0]

                if (!firstPhoto || !firstPhoto.MediaItem) {
                    return null
                }

                return firstPhoto.MediaItem.Id
            }
        },

        created: function () {
            const vm = this

            vm.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
            vm.$store.dispatch('updateSearchFilter', { key: 'showAllResults', value: true })

            vm.$eventHub.$on('search-filtersChanged', vm.onFiltersChanged)
        },

        data() {
            return {
                center: { lat: 57.4679769, lng: -4.2918971 },
                itemInfoStatus: 'closed',
                loading: true,
                mapLoaded: false,
                mapMarkers: [],
                mapObject: null,
                markerClusterer: null,
                markerRenderId: 0,
                oms: null,
                propertySummary: null,
                searchApiUrl: '/umbraco/api/PropertySearchApi/Search'
            }
        },

        methods: {
            clickMarker: function (markerPosition, propertyId) {
                var vm = this
                vm.center = markerPosition
                vm.loading = true

                const getPropertySummary = function () {
                    return Axios.get(
                        '/umbraco/api/PropertySearchApi/Summary', {
                            params: {
                                propertyId: propertyId
                            }
                        }
                    )
                }

                Axios.all([getPropertySummary()])
                    .then(Axios.spread(function (response) {

                        if (response && response.data) {
                            vm.propertySummary = response.data
                            vm.itemInfoStatus = 'open'
                        }

                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            },

            clearMapMarkers: function () {
                if (this.markerClusterer) {
                    this.markerClusterer.clearMarkers()

                    if (this.markerClusterer.setMap) {
                        this.markerClusterer.setMap(null)
                    }

                    this.markerClusterer = null
                }

                this.mapMarkers.forEach(removeMarker)
                this.mapMarkers = []
            },

            init: function () {
                this.search(true)
            },

            onFiltersChanged: function () {
                this.search(true)
            },

            toggleItemInfoStatus: function () {
                this.itemInfoStatus = this.itemInfoStatus == 'closed' ? 'open' : 'closed'
            },

            renderMapMarkers: async function () {
                if (!this.mapObject) {
                    return
                }

                const markerRenderId = this.markerRenderId + 1
                this.markerRenderId = markerRenderId

                this.clearMapMarkers()

                if (!this.markers || this.markers.length === 0) {
                    return
                }

                await loadAdvancedMarkerLibraryForMap(this.mapOptions)

                if (markerRenderId !== this.markerRenderId) {
                    return
                }

                this.mapMarkers = this.markers.map(markerData => {
                    const marker = createMapIconMarker({
                        position: markerData.position,
                        icon: this.markerIcon,
                        mapObject: this.mapObject
                    })

                    addMapMarkerClickListener(marker, () => {
                        this.clickMarker(markerData.position, markerData.propertyId)
                    })

                    return marker
                })

                this.markerClusterer = createMarkerClusterer({
                    map: this.mapObject,
                    markers: this.mapMarkers,
                    maxZoom: 18
                })

                this.$nextTick(() => {
                    window.requestAnimationFrame(() => {
                        if (this.markerClusterer && this.markerClusterer.redraw) {
                            this.markerClusterer.redraw()
                        }
                    })
                })
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mounted: function () {
            const vm = this

            vm.$gmapApiPromiseLazy().then(() => {
                vm.$refs.gmap.$mapPromise.then(map => {
                    vm.mapObject = map
                    vm.init()
                    vm.mapLoaded = true
                })
            })
        },

        mixins: [globalMixin, propertyMixin, searchMixin],

        props: {
            listViewUrl: {
                type: String
            }
        },

        unmounted: function () {
            this.markerRenderId += 1
            this.clearMapMarkers()
        },

        watch: {
            markers: function () {
                this.$nextTick(this.renderMapMarkers)
            }
        }
    }
</script>

<style>
    .property-search-map__map {
        width: 100%;
        height: 100%;
    }
</style>
